import { LDFlagSet } from 'launchdarkly-js-sdk-common';
import IFeatureFlagClient from './IFeatureFlagClient';
import { GetFeatureFlagParams } from './types';
import { LDFlagValue } from 'launchdarkly-js-client-sdk';

export default class FallbackFeatureFlagClient implements IFeatureFlagClient {
  public async getFeatureFlag(
    params: GetFeatureFlagParams
  ): Promise<LDFlagValue> {
    return params.defaultValue;
  }

  public async getAllFeatureFlags(): Promise<LDFlagSet> {
    return;
  }
}
